<template>
    <div class="page-setting has-bc biz-personal-center">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
        </div>
        <personal-center-comp></personal-center-comp>
    </div>
</template>
<script>
import personalCenterComp from '@/components/bussiness/personalCenter/personalCenter/personalCenterComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {

        }
    },
    computed: {
        ...mapGetters({
           
        })
    },
    components: {
        personalCenterComp
    }
}
</script>
<style lang="scss">
    // .biz-personal-center{
    //     .biz-personal-center-wrap{
            
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalCenter/personalCenterDefault.vue